/**
 * Single `QueryClient` instance for the Web SPA. Defaults are deliberately
 * conservative — every individual `useQuery` is expected to set an explicit
 * `staleTime` rather than rely on the global default.
 *
 * Why retries are disabled by default:
 *   - The Server returns structured errors (`ApiError`) and we'd rather
 *     surface them immediately than mask transient bugs behind retries.
 *   - Individual hooks can opt in to `retry` per call if they need it.
 */

import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/lib/fetcher';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Never retry on 4xx; retry once on 5xx / network errors.
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 1;
      },
      refetchOnWindowFocus: false,
      // Intentionally no `staleTime` default — each query must declare its own.
    },
    mutations: {
      retry: false,
    },
  },
});
